import React, {useState, useEffect} from "react";
import "./Reports.scss";
import {motion} from "framer-motion";
import {client} from "../../../../client";
import {Link} from "react-router-dom";

const ReportCard = ({report, index}) => {
  return (
    <motion.div
      className="report-card"
      initial={{opacity: 0, y: 30}}
      whileInView={{opacity: 1, y: 0}}
      viewport={{once: true}}
      transition={{duration: 0.6, delay: index * 0.1, ease: "easeOut"}}
    >
      <div className="card-top">
        <div className="image-container">
          <img src={report.mainImage?.asset?.url} alt={report.title} />
        </div>
        <Link to={`/report/${report.slug?.current}`} className="read-article">
          <span>Read Report</span>
          <div className="arrow-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </Link>
      </div>
      <div className="card-bottom">
        <h4 className="report-title">{report.title}</h4>
      </div>
    </motion.div>
  );
};

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "report"] | order(_updatedAt desc) [0...3] {
                title, 
                slug,
                mainImage {
                    asset -> {
                        url
                    }
                }
            }`,
      )
      .then((data) => {
        setReports(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="reports-section">
        <div className="reports-container">
          <p>Loading reports...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="reports-section">
      <div className="reports-container">
        {reports.map((report, index) => (
          <ReportCard
            key={report.slug?.current || index}
            report={report}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default Reports;
